import { useEffect, useState, useCallback } from 'react';
import { FaSearch, FaFilter, FaUsers, FaEnvelope, FaBuilding } from 'react-icons/fa';
import { supabase } from '../../supabaseClient';
import '../../styles/styles.css';

export default function UserSearch() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [emailFilter, setEmailFilter] = useState('');
  const [lubricentroFilter, setLubricentroFilter] = useState('');

  // La función useCallback es para que la función fetchUsers no se cree cada vez que se renderice el componente
  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      let query = supabase
        .from('profiles')
        .select('id, first_name, last_name, email, lubricentro')
        .order('created_at', { ascending: false });

      if (emailFilter.trim() !== '') {
        query = query.ilike('email', `%${emailFilter.trim()}%`);
      }
      if (lubricentroFilter.trim() !== '') {
        query = query.ilike('lubricentro', `%${lubricentroFilter.trim()}%`);
      }
      
      const { data, error } = await query;
      if (error) throw error;
      setUsers(data);
    } catch (err) {
      setError(err.message);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  }, [emailFilter, lubricentroFilter]); // Se activa cada vez que cambian los filtros

  const clearFilters = () => {
    setEmailFilter('');
    setLubricentroFilter('');
  };

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]); // Llama a la función de búsqueda cada vez que cambia

  return (
    <div className="animate-fade-in">
      <div className="filters-container">
        <div className="filters-title">
          <FaFilter className="text-accent" /> Filtros de Usuarios
        </div>
        <div className="filters-grid">
          <div className="input-group">
            <input
              className="form-input"
              placeholder="Buscar por email"
              value={emailFilter}
              onChange={(e) => setEmailFilter(e.target.value)}
            />
            <FaEnvelope className="input-icon" />
          </div>
          <div className="input-group">
            <input
              className="form-input"
              placeholder="Buscar por lubricentro"
              value={lubricentroFilter}
              onChange={(e) => setLubricentroFilter(e.target.value)}
            />
            <FaBuilding className="input-icon" />
          </div>
        </div>
        <div className="flex gap-2 mt-4">
          <button className="btn btn-ghost" onClick={clearFilters}>
            Limpiar Filtros
          </button>
          <button className="btn btn-primary" onClick={fetchUsers}>
            <FaSearch /> Buscar
          </button>
        </div>
      </div>

      <div className="table-container mt-4">
        {loading && <div className="loading p-8">Cargando usuarios...</div>}
        {error && <div className="error m-4">Error: {error}</div>}
        {!loading && users.length === 0 && (
          <div className="info m-4">No se encontraron usuarios.</div>
        )}
        {!loading && users.length > 0 && (
          <div className="overflow-x-auto">
            <table className="table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Apellido</th>
                  <th>Email</th>
                  <th>Lubricentro</th>
                </tr>
              </thead>
              <tbody>
                {users.map((u) => (
                  <tr
                    key={u.id}
                    className="hover:bg-card-hover transition-colors"
                  >
                    <td>{u.first_name || '-'}</td>
                    <td>{u.last_name || '-'}</td>
                    <td>{u.email}</td>
                    <td>{u.lubricentro || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}